"use strict";var a=Object.defineProperty;var g=Object.getOwnPropertyDescriptor;var t=(c,l,e,r)=>{for(var i=r>1?void 0:r?g(l,e):l,n=c.length-1,h;n>=0;n--)(h=c[n])&&(i=(r?h(l,e,i):h(i))||i);return r&&i&&a(l,e,i),i};import{baseStyles as y,CiscoUElement as f,html as o,nothing as m}from"@cisco-u/base";import{property as s}from"@cisco-u/base/src/decorators.js";import{classMap as u,styleMap as p}from"@cisco-u/base/src/directives.js";import d from"./avatar.css.js";import"@cisco-u/icons/icons/cu-icon-check.js";import"@cisco-u/stickers/cu-stickers.js";export class Avatar extends f{constructor(){super(...arguments);this.certified=!1}static get styles(){return[y,d]}render(){const e=this._setStyles(),r=this._setClasses();return o`
      <div
        class=${u({...r,"umask-wrap":!0})}
        style=${p({...e})}
      >
        <div
          style=${p({...e})}
          class=${u({...r,umask:"umask"})}
        >
          ${this.letters?this._returnLetterEle():o`<img src=${this.src} alt=${this.alt} />`}
        </div>
        ${this.certified?o`<cu-stickers
              shape="star-1"
              bgColor="blue-light"
              stickerDiameter="1.3125rem"
              style="--text-color: var(--color-white)"
            >
              <cu-icon-check size="s"></cu-icon-check>
            </cu-stickers>`:m}
      </div>
    `}_returnLetterEle(){return o`<div
      class="avatar-letters"
      style=${p({fontSize:this.fontSize})}
    >
      <span>${this.letters}</span>
    </div>`}_setStyles(){const e={};return this.width&&(e.width=this.width),this.height&&(e.height=this.height),e}_setClasses(){return{"cisco-one":this.cisco_one,"cisco-two":this.cisco_two}}}t([s({type:String,reflect:!0})],Avatar.prototype,"height",2),t([s({type:String,reflect:!0})],Avatar.prototype,"src",2),t([s({type:String,reflect:!0})],Avatar.prototype,"width",2),t([s({type:String,reflect:!0})],Avatar.prototype,"alt",2),t([s({type:Boolean,reflect:!0})],Avatar.prototype,"cisco_one",2),t([s({type:Boolean,reflect:!0})],Avatar.prototype,"cisco_two",2),t([s({type:String,reflect:!0})],Avatar.prototype,"letters",2),t([s({type:String,reflect:!0})],Avatar.prototype,"fontSize",2),t([s({type:Boolean,reflect:!0})],Avatar.prototype,"certified",2);
//# sourceMappingURL=Avatar.js.map
